const initState = {
  sportBadge: [],
  totalSportBadgeEarning: 0,
  hasMoreSportBadge: true,
  lastDocumentSportBadge: "",
  seasonalBadge: [],
  totalSeasonalBadgeEarning: 0,
  hasMoreSeasonalBadge: true,
  lastDocumentSeasonalBadge: "",
  endorsementBadge: [],
  totalEndorsementBadgeEarning: 0,
  hasMoreEndorsementBadge: true,
  lastDocumentEndorsementBadge: "",
  talkingBadge: [],
  totalTalkingBadgeEarning: 0,
  hasMoreTalkingBadge: true,
  lastDocumentTalkingBadge: "",
  honorBadge: [],
  totalHonorBadgeEarning: 0,
  hasMoreHonorBadge: true,
  lastDocumentHonorBadge: "",
  voteGetterBadge: [],
  totalVoteGetterBadgeEarning: 0,
  hasMoreVoteGetterBadge: true,
  lastDocumentVoteGetterBadge: "",
  momento: [],
  totalMomentoEarning: 0,
  hasMoreMomento: true,
  lastDocumentMomento: "",
  singleChat: [],
  totalSingleChatEarning: 0,
  hasMoreSingleChat: true,
  lastDocumentSingleChat: "",
  groupChat: [],
  totalGroupChatEarning: 0,
  hasMoreGroupChat: true,
  lastDocumentGroupChat: "",
  contest: [],
  totalContestEarning: 0,
  hasMoreContest: true,
  lastDocumentContest: "",
  pizzaMoney: [],
  totalPizzaMoneyEarning: 0,
  hasMorePizzaMoney: true,
  lastDocumentPizzaMoney: "",
};

const AthleteEarningsReducer = (state = initState, action) => {
  switch (action.type) {
    case "TOTAL_EARINGS_BY_SECTIONS":
      return {
        ...state,
        [action.payload.key]: action.payload.totalEarnings,
      };
    case "ATHLETE_PIZZA_MONEY_EARNINGS":
      return {
        ...state,
        pizzaMoney: action.payload.data,
        hasMorePizzaMoney: action.payload.hasMoreDocument,
        lastDocumentPizzaMoney: action.payload.lastDocument,
      };
    case "MORE_ATHLETE_PIZZA_MONEY_EARNINGS":
      return {
        ...state,
        pizzaMoney: [...state.pizzaMoney, ...action.payload.data],
        hasMorePizzaMoney: action.payload.hasMoreDocument,
        lastDocumentPizzaMoney: action.payload.lastDocument,
      };

    case "SPORT_BADGE":
      return {
        ...state,
        sportBadge: action.payload.data,
        hasMoreSportBadge: action.payload.hasMoreDocument,
        lastDocumentSportBadge: action.payload.lastDocument,
      };
    case "SPORT_BADGE_LOAD_MORE":
      return {
        ...state,
        sportBadge: [...state.sportBadge, ...action.payload.data],
        hasMoreSportBadge: action.payload.hasMoreDocument,
        lastDocumentSportBadge: action.payload.lastDocument,
      };
    case "SEASONAL_BADGE":
      return {
        ...state,
        seasonalBadge: action.payload.data,
        hasMoreSeasonalBadge: action.payload.hasMoreDocument,
        lastDocumentSeasonalBadge: action.payload.lastDocument,
      };
    case "SEASONAL_BADGE_LOAD_MORE":
      return {
        ...state,
        seasonalBadge: [...state.seasonalBadge, ...action.payload.data],
        hasMoreSeasonalBadge: action.payload.hasMoreDocument,
        lastDocumentSeasonalBadge: action.payload.lastDocument,
      };
    case "ENDORSEMENT_BADGE":
      return {
        ...state,
        endorsementBadge: action.payload.data,
        hasMoreEndorsementBadge: action.payload.hasMoreDocument,
        lastDocumentEndorsementBadge: action.payload.lastDocument,
      };
    case "ENDORSEMENT_BADGE_LOAD_MORE":
      return {
        ...state,
        endorsementBadge: [...state.endorsementBadge, ...action.payload.data],
        hasMoreEndorsementBadge: action.payload.hasMoreDocument,
        lastDocumentEndorsementBadge: action.payload.lastDocument,
      };
    case "TALKING_BADGE":
      return {
        ...state,
        talkingBadge: action.payload.data,
        hasMoreTalkingBadge: action.payload.hasMoreDocument,
        lastDocumentTalkingBadge: action.payload.lastDocument,
      };
    case "TALKING_BADGE_LOAD_MORE":
      return {
        ...state,
        talkingBadge: [...state.talkingBadge, ...action.payload.data],
        hasMoreTalkingBadge: action.payload.hasMoreDocument,
        lastDocumentTalkingBadge: action.payload.lastDocument,
      };
    case "HONOR_BADGE":
      return {
        ...state,
        honorBadge: action.payload.data,
        hasMoreHonorBadge: action.payload.hasMoreDocument,
        lastDocumentHonorBadge: action.payload.lastDocument,
      };
    case "HONOR_BADGE_LOAD_MORE":
      return {
        ...state,
        honorBadge: [...state.honorBadge, ...action.payload.data],
        hasMoreHonorBadge: action.payload.hasMoreDocument,
        lastDocumentHonorBadge: action.payload.lastDocument,
      };
    case "VOTE_GETTER_BADGE":
      return {
        ...state,
        voteGetterBadge: action.payload.data,
        hasMoreVoteGetterBadge: action.payload.hasMoreDocument,
        lastDocumentVoteGetterBadge: action.payload.lastDocument,
      };
    case "VOTE_GETTER_BADGE_LOAD_MORE":
      return {
        ...state,
        voteGetterBadge: [...state.voteGetterBadge, ...action.payload.data],
        hasMoreVoteGetterBadge: action.payload.hasMoreDocument,
        lastDocumentVoteGetterBadge: action.payload.lastDocument,
      };
    case "MOMENTO":
      return {
        ...state,
        momento: action.payload.data,
        hasMoreMomento: action.payload.hasMoreDocument,
        lastDocumentMomento: action.payload.lastDocument,
      };
    case "MOMENTO_LOAD_MORE":
      return {
        ...state,
        momento: [...state.momento, ...action.payload.data],
        hasMoreMomento: action.payload.hasMoreDocument,
        lastDocumentMomento: action.payload.lastDocument,
      };
    case "SINGLE_CHAT":
      return {
        ...state,
        singleChat: action.payload.data,
        hasMoreSingleChat: action.payload.hasMoreDocument,
        lastDocumentSingleChat: action.payload.lastDocument,
      };
    case "SINGLE_CHAT_MORE":
      return {
        ...state,
        singleChat: [...state.singleChat, ...action.payload.data],
        hasMoreSingleChat: action.payload.hasMoreDocument,
        lastDocumentSingleChat: action.payload.lastDocument,
      };
    case "GROUP_CHAT":
      return {
        ...state,
        groupChat: action.payload.data,
        hasMoreGroupChat: action.payload.hasMoreDocument,
        lastDocumentGroupChat: action.payload.lastDocument,
      };
    case "GROUP_CHAT_MORE":
      return {
        ...state,
        groupChat: [...state.groupChat, ...action.payload.data],
        hasMoreGroupChat: action.payload.hasMoreDocument,
        lastDocumentGroupChat: action.payload.lastDocument,
      };
    case "CONTEST_EARNINGS":
      return {
        ...state,
        contest: action.payload.data,
        hasMoreContest: action.payload.hasMoreDocument,
        lastDocumentContest: action.payload.lastDocument,
      };
    case "CONTEST_MORE":
      return {
        ...state,
        contest: [...state.contest, ...action.payload.data],
        hasMoreContest: action.payload.hasMoreDocument,
        lastDocumentContest: action.payload.lastDocument,
      };

    default:
      return {
        ...state,
      };
  }
};
export default AthleteEarningsReducer;
